/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Location/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Location({
  children,
  viewPath = "/App/ChooseLocation/Locations/Content/Location",
  isSubmitting
  
}) {
let selectedLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'location_id',
})
let locationIdValueData = fromData.useDataValue({ viewPath,
context: 'location',
path: 'id',
})
let aggregateData = fromAggregate.equals(selectedLocationIdValueData, locationIdValueData)
let selectedIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'selected',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
let locationNameValueData = fromData.useDataValue({ viewPath,
context: 'location',
path: 'name',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginTop={dtSpaceXxs}
 marginRight={dtSpaceXxs}
 onClick={onClick}
 data="selected.location_id"
 data="location.id"
 aggregate="/Data/aggregate.js equals"
 selected={aggregateData}
 data="selected"
 disabled={selectedIsSubmittingData}
 type="secondary"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="location.name"
 text={locationNameValueData}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}